/**
 * The product's own name, in one place.
 *
 * Before this file existed the name was hardcoded in 38 files — page titles,
 * PDF footers, aria-labels, the manifest, the WhatsApp support message. Renaming
 * the product meant finding all of them, and the ones that got missed were the
 * ones nobody looks at (an aria-label, a footer on a PDF that prints once a
 * quarter). Import from here instead of typing the name.
 *
 * The backend has its own copy in config/app.php, driven by APP_NAME, because
 * Blade and PDF rendering happen server-side and cannot read this module.
 * `BrandNameTest` asserts the two agree, so they cannot drift apart silently.
 */
export const APP_NAME = 'Pakka Hisaab';

/**
 * For places with no room for the full name — the PWA manifest's `short_name`
 * (Android home screens truncate past ~12 chars) and the Windows taskbar label.
 */
export const APP_SHORT_NAME = 'Pakka Hisaab';

/** Tagline used on the marketing/auth surfaces. */
export const APP_TAGLINE = 'Built for Indian SMEs';

/** `Invoices · Pakka Hisaab` — the document-title format used by Inertia. */
export function pageTitle(title?: string): string {
  return title ? `${title} · ${APP_NAME}` : APP_NAME;
}
